/**
 * Mapowanie typów produktów wykrytych przez YOLO na kategorie produktów
 */
export const PRODUCT_TYPE_TO_CATEGORY: Record<string, string> = {
  't-shirt': 'Odzież',
  'bottle': 'Napoje',
  'can': 'Napoje',
  'box': 'Elektronika',
  'pallet': 'Logistyka',
  'bag': 'Akcesoria',
  'container': 'Pojemniki',
  'other': 'Inne',
};

/**
 * Mapuje detectedType na kategorię produktu
 */
export function mapTypeToCategory(detectedType: string): string {
  return PRODUCT_TYPE_TO_CATEGORY[detectedType] || PRODUCT_TYPE_TO_CATEGORY['other'];
}

/**
 * Generuje nazwę produktu na podstawie wyników detekcji
 */
export function generateProductName(
  detectedBrand?: string,
  detectedType?: string,
  detectedColor?: string
): string {
  const parts: string[] = [];

  if (detectedBrand) {
    parts.push(detectedBrand);
  }

  if (detectedType) {
    parts.push(detectedType);
  }

  if (detectedColor) {
    parts.push(detectedColor);
  }

  if (parts.length === 0) {
    return 'Nowy produkt';
  }

  return parts.join(' ');
}

